import { useAIChatbotAccess } from "@faire/help-center-self-serve/hooks/useAIChatbotAccess";
import { isRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import { useBrandMilestone } from "@faire/help-center-utils/src/hooks/useBrandMilestones";
import { useRetailerMilestone } from "@faire/help-center-utils/src/hooks/useRetailerMilestones";
import { DismissableTooltip } from "@faire/web/slate/Tooltip/DismissableTooltip";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var ChatbotTooltip = function ChatbotTooltip() {
  var hasAIChatbotAccess = useAIChatbotAccess();
  var _useRetailerMilestone = useRetailerMilestone("RETAILER_DECAGON_AI_CHATBOT_TOOLTIP_SEEN"),
    retailerChatbotTooltipHasOccurred = _useRetailerMilestone.hasOccurred,
    setRetailerChatbotTooltipOccurred = _useRetailerMilestone.setHasOccurred,
    retailerMilestoneIsLoading = _useRetailerMilestone.isLoading;
  var _useBrandMilestone = useBrandMilestone("BRAND_DECAGON_AI_CHATBOT_TOOLTIP_SEEN"),
    brandChatbotTooltipHasOccurred = _useBrandMilestone.hasOccurred,
    setBrandChatbotTooltipOccurred = _useBrandMilestone.setHasOccurred,
    brandMilestoneIsLoading = _useBrandMilestone.isLoading;
  if (!hasAIChatbotAccess) {
    return null;
  }
  if (retailerMilestoneIsLoading || brandMilestoneIsLoading) {
    return null;
  }
  if (isRetailer() && retailerChatbotTooltipHasOccurred) {
    return null;
  }
  if (!isRetailer() && brandChatbotTooltipHasOccurred) {
    return null;
  }
  var handleDismiss = function handleDismiss() {
    if (isRetailer()) {
      setRetailerChatbotTooltipOccurred();
    } else {
      setBrandChatbotTooltipOccurred();
    }
  };
  return /*#__PURE__*/React.createElement(TooltipWrapper, {
    targetNode: /*#__PURE__*/React.createElement(React.Fragment, null),
    position: "top",
    pointerOffset: 80,
    onDismiss: handleDismiss
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansMedium",
    color: "inherit"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "AUC5sw",
    defaultMessage: [{
      "type": 0,
      "value": "Testez notre nouvel assistant virtuel"
    }]
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansRegular",
    color: "inherit"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "xWmF3q",
    defaultMessage: [{
      "type": 0,
      "value": "Des questions sur les commandes, les retours, etc. ? Demandez à notre assistant. Il est disponible à tout moment et vous met en relation avec des spécialistes de l'assistance si vous avez besoin d'une aide supplémentaire."
    }]
  })));
};
var TooltipWrapper = styled(DismissableTooltip).withConfig({
  displayName: "ChatbotTooltip__TooltipWrapper"
})(["position:fixed;bottom:78px;right:108px;"]);